var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file [Please Input File Description]
 * @author (zhuwanying02) if any problem, please call me.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import SidebarNormal from './Sidebar.js';
import SidebarResponsive from './SidebarResponsive.js';

/* global window */

var Sidebar = function (_Component) {
    _inherits(Sidebar, _Component);

    function Sidebar() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Sidebar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Sidebar.__proto__ || Object.getPrototypeOf(Sidebar)).call.apply(_ref, [this].concat(args))), _this), _this.state = { responsive: false }, _this.isResponsive = function () {
            var clientWidth = window.innerWidth;

            if (clientWidth <= 800) {
                _this.setState({
                    responsive: true
                });
            } else {
                _this.setState({
                    responsive: false
                });
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Sidebar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.responsive) {
                this.isResponsive();
                window.addEventListener('resize', this.isResponsive);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.responsive) {
                window.removeEventListener('resize', this.isResponsive);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.responsive && this.props.responsive) {
                return React.createElement(SidebarResponsive, this.props);
            } else {
                return React.createElement(SidebarNormal, this.props);
            }
        }
    }]);

    return Sidebar;
}(Component);

Sidebar.propTypes = {
    responsive: PropTypes.bool
};
export default Sidebar;